import { useQuery } from '@tanstack/react-query';
import api, { DocumentSignEnvelopeListResponse, DocumentSignEnvelopeStatus } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseEnvelopesParams {
  status?: DocumentSignEnvelopeStatus[];
  search?: string;
  sortBy?: 'created_at' | 'sent_at' | 'completed_at';
  limit?: number;
  offset?: number;
}

interface UseEnvelopesReturn {
  envelopes: DocumentSignEnvelopeListResponse['envelopes'];
  total: number;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useEnvelopes(params: UseEnvelopesParams = {}): UseEnvelopesReturn {
  const filterKey = {
    status: params.status ?? null,
    search: params.search ?? null,
    sortBy: params.sortBy ?? null,
    limit: params.limit ?? null,
    offset: params.offset ?? null,
  };

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.documentSign.envelopeList(filterKey),
    queryFn: () => api.listDocumentSignEnvelopes(params),
    placeholderData: (prev) => prev,
  });

  return {
    envelopes: data?.envelopes ?? [],
    total: data?.total ?? 0,
    limit: data?.limit ?? params.limit ?? 20,
    offset: data?.offset ?? params.offset ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load envelopes' : null,
    refresh: () => {
      refetch();
    },
  };
}
